import { PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID } from 'owa-folders-constants';
import { getApolloClient } from 'owa-apollo';
import {
    PrimaryMailFolderHierarchyDocument,
    PrimaryMailFolderHierarchyQuery,
    PrimaryMailFolderHierarchyQueryVariables,
} from 'owa-mail-folder-tree-container-view';
import { shouldShowFolder } from 'owa-folders-data-utils';
import type { SessionData } from 'owa-service/lib/types/SessionData';
import { extractFolderHierarchy } from 'owa-folders/lib/util/extractFolderHierarchy';
import { errorThatWillCauseAlert } from 'owa-trace';
import { getUserMailboxInfo } from 'owa-client-ids';

export function bootstrapFolderHierarchyCache(sessionData: SessionData | undefined) {
    try {
        const userMailboxInfo = getUserMailboxInfo();
        const folderHierarchy = extractFolderHierarchy(sessionData, userMailboxInfo);

        if (folderHierarchy) {
            const data: PrimaryMailFolderHierarchyQuery = {
                folderHierarchy,
            };

            const variables: PrimaryMailFolderHierarchyQueryVariables = {
                baseFolderDistinguishedIds: [PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID],
                offset: 0,
                mailboxInfo: userMailboxInfo,
                shouldShowJunkEmailFolder: shouldShowFolder('junkemail'),
                shouldShowNotesFolder: shouldShowFolder('notes'),
            };

            getApolloClient().writeQuery({
                query: PrimaryMailFolderHierarchyDocument,
                variables,
                data,
            });
        }
    } catch (e) {
        errorThatWillCauseAlert(e);
    }
}
